export default {
  id: "supplierFilter",
  type: "ui",
  name: "",
  description: "",
  report: {
    name: "Filter Suppliers",
    template: "supplier-filter",
    config: {},
  },
};
